import { render, staticRenderFns } from "./ProductsForm.vue?vue&type=template&id=5278a37e&"
import script from "./ProductsForm.vue?vue&type=script&lang=js&"
export * from "./ProductsForm.vue?vue&type=script&lang=js&"
import style0 from "./ProductsForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports